<template>
  <div class="container">
    <div class="matchResult main-width">
      <div class="matchInfo">
        <h3 class="title m_t10">
          {{ matchDetails.title }}
          <el-button
            type="primary"
            class="reortDownlaid"
            @click="downloadReport"
            >报告下载</el-button
          >
        </h3>
        <ul class="infoDetail">
          <li>
            <p>
              所属区划:<span>{{ matchDetails.addressName }}</span>
            </p>
            <p>
              部门:<span>{{ matchDetails.departmentName }}</span>
            </p>
          </li>
          <li>
            <p>
              政策分类:<span>{{ matchDetails.nature }}</span>
            </p>
            <p>
              扶持金额:<span>{{ matchDetails.supportAmount }}万元</span>
            </p>
          </li>
          <li>
            <p>申报对象:<span>企业</span></p>
            <p>
              受理日期:<span
                >{{ matchDetails.releaseDate }} 至{{
                  matchDetails.deadline
                }}</span
              >
            </p>
          </li>
        </ul>
      </div>
      <el-tabs
        class="matchResultTab"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane class="tabTitle" label="政策指标" name="first">
          <div class="tabDetail">
            <p class="matchLevel">
              匹配度<span>{{ matchDetails.matchLevel }}</span>
            </p>
            <div v-for="item in tables" :key="item.title">
              <p class="matchLevel">
                {{ item.title }}
              </p>
              <el-table
                class="indexTable"
                :data="item.items"
                style="width: 100%"
              >
                <el-table-column
                  prop="dispatchObject"
                  align="center"
                  label="政策指标"
                  min-width="25.5%"
                >
                  <template slot-scope="scope">
                    <el-popover
                      trigger="hover"
                      placement="top"
                      v-if="scope.row.fieldDesc"
                    >
                      <p>{{ scope.row.fieldDesc }}</p>
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.fieldDesc }}</el-tag>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="matchDesc"
                  align="center"
                  label="指标详情"
                  min-width="49%"
                >
                  <template slot-scope="scope">
                    <el-popover
                      trigger="hover"
                      placement="top"
                      v-if="scope.row.matchDesc"
                    >
                      <p>{{ scope.row.matchDesc }}</p>
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.matchDesc }}</el-tag>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="result"
                  align="center"
                  label="匹配情况"
                  min-width="25.5%"
                >
                  <template slot-scope="scope">
                    <span class="result" v-if="scope.row.result == 1">
                      <i
                        class="el-icon-success matchIcon match-resIcon"
                        :title="scope.row.result"
                      ></i>
                      匹配
                    </span>
                    <span class="result" v-if="scope.row.result == 2">
                      <i
                        class="el-icon-question conditionIcon match-resIcon"
                        :title="scope.row.result"
                      ></i>
                      待完善
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="tabTitle" label="政策详情" name="second">
          <div class="tabDetail">
            <div class="policy">
              <div class="title">{{ pageData.title }}</div>
              <div class="show m_t30">
                <span v-if="pageData.department"
                  >部门:
                  {{
                    pageData.departmentName ? pageData.departmentName : null
                  }}</span
                >
          <!--      <span class="m_l30">浏览量: {{ pageData.pageView || 0 }}</span> -->
                <span class="m_l30">时间: {{ pageData.releaseDate }}</span>
              </div>
              <div
                class="m_t40 lh1_5 rich-text"
                style="line-height: 1.5"
                :class="[
                  pageData.enclosureVoList &&
                  pageData.enclosureVoList.length === 0
                    ? 'm_b50'
                    : '',
                ]"
                v-html="pageData.content"
              ></div>
              <div
                class="added m_b50"
                v-if="
                  pageData.enclosureVoList &&
                  pageData.enclosureVoList.length > 0
                "
              >
                <div class="added_title">相关附件</div>
                <div class="added_file m_t30">
                  <div
                    class="added_file_item m_b10 btn color_blue flex item-end"
                    @click="download(item)"
                    v-for="(item, index) in pageData.enclosureVoList"
                    :key="index"
                  >
                    <span>
                      <img
                        style="width: 34px"
                        src="@images/icon/pdf_icon@3x.png"
                        alt=""
                      />
                    </span>
                    <span style="margin-left: 12px">
                      {{ item.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { getPolicyDetail, data_publicy, getReport } from "@/api/policy";
export default {
  name: "matchResult",
  data() {
    return {
      activeName: "first",
      tableData: [],
      detailData: [
        {
          index: "北京市引进人才住房保障的奖励",
          detail: "",
          conditionStatu: null,
        },
        {
          index: "注册省",
          detail: "北京市-海淀区",
          conditionStatu: 1,
        },
        {
          index: "成立日期",
          detail: "2018年5月13日之后",
          conditionStatu: 2,
        },
        {
          index: "企业资质",
          detail: "总部企业",
          conditionStatu: 2,
        },
      ],
      matchDetails: {},
      tableData222: [],
      pageData: {},
      tables: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.id != from.query.id) {
        this.id = to.query.id;
        this.getDetails(); //重新加载数据
      }
    },
  },
  created() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      let vm = this;
      let { areaCode, id, params } = this.$route.query;
      if (!areaCode || !id || !params) return;
      const res = getPolicyDetail({
        code: areaCode,
        policyId: id,
        unitName: params,
      })
        .then((res) => {
          const { code, result, msg } = res.data;
          let data = result;

          if (code === 200 && data) {
            vm.matchDetails = data;
            vm.tables = [];
            data.matchRecordList.forEach((item) => {
              let child = JSON.parse(
                JSON.stringify(item.items).replace(
                  new RegExp("fieldDesc", "g"),
                  "dispatchObject"
                )
              );
              vm.tables.push(item);
            });
            this.getDetails2(data.adminPolicies.id);
            console.log(vm.tables, "tables");
          }
        })
        .catch((e) => console.error(e));
    },
    async getDetails2(id) {
      let vm = this;
      const res = await data_publicy(id)
        .then((res) => {
          const { code, result, msg } = res.data;
          if (code === 200 && result) {
            this.pageData = result;
          }
        })
        .catch((e) => console.error(e));
      // this.pageData = this.matchDetails.adminPolicies;
    },
    handleClick() {
      if (this.activeName == "first") {
        this.getDetails();
      } else {
        // this.getDetails2();
      }
    },
    downloadReport() {
      getReport({
        name: this.$route.query.params,
        policyId: this.$route.query.id,
      })
        .then((res) => {
          const { code, result, msg } = res.data;
          let data = result;
          this.$alert("匹配报告密码为登录手机号后四位", "报告下载", {
            confirmButtonText: "去下载",
            callback: (action) => {
              window.open(data);
            },
          });
        })
        .catch((e) => console.error(e));
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
}
.matchResult {
  width: 1200px;
  .matchInfo {
    background: #fff;
    padding: 26px 26px 20px;
    * {
      margin: 0;
      padding: 0;
    }
    .title {
      font-size: 33px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 700;
      color: #535256;
      line-height: 48px;
      margin-bottom: 20px;
    }
    .infoDetail {
      li {
        display: flex;
        flex-direction: row;
        line-height: 40px;
        height: 40px;
        p {
          flex: 1;
          color: #a1a1a1;
          line-height: 40px;
          span {
            color: #4e4e4e;
            display: inline-block;
            margin-left: 8px;
          }
        }
      }
    }
  }
  .policy {
    width: 1000px;
    margin: 0 auto;
    .added {
      .added_title {
        font-size: 18px;
        font-weight: 500;
        text-align: left;
        color: $black;
        line-height: 38px;
        margin-top: 30px;
        border-bottom: 4px solid $black;
      }
    }

    &.main-width {
      width: 1000px;
    }

    .title {
      font-size: 24px;
      font-weight: 500;
      text-align: left;
      color: $black;
      line-height: 60px;
      margin-top: 34px;
    }

    .show {
      color: #999;
      padding-bottom: 12px;
      border-bottom: 1px solid #999;
    }
  }
  .matchResultTab {
    margin-top: 20px;
    // /deep/.el-tabs__active-bar {
    //   display: none;
    // }
    // /deep/.el-tabs__item.is-active {
    //   background-color: #3468ce;
    //   color: white;
    //   padding-left: 20px;
    //   font-size: 16px;
    // }
    // /deep/.el-tabs__nav-wrap::after {
    //   display: none;
    // }
    // /deep/.el-tabs__item {
    //   margin-right: 20px;
    //   background-color: #c6c6c6;
    //   color: white;
    //   padding: 0 20px;
    //   font-size: 16px;
    // }

    /deep/ .el-tabs__nav {
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #e1e5f1;
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__item {
        height: 50px;
        line-height: 50px;
        padding: 0 40px;

        font-size: 18px;
        font-weight: 400;
        color: #535256;
        &:nth-child(3),
        &:nth-child(4) {
          border-left: 1px solid #e1e5f1;
        }
        &.is-active {
          background: rgba(32, 85, 201, 0.1);
          font-size: 18px;
          font-weight: 700;
          color: #2055c9;
          margin: 3px;
          height: 45px;
          line-height: 45px;
          border: none;
          & + .el-tabs__item {
            border: none;
          }
        }
      }
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    .tabDetail {
      background: #fff;
      // border: 1px solid #f4f3f2;
      padding: 30px;
      box-sizing: border-box;
      width: 100%;
      /deep/ strong {
        display: block;
        line-height: 3;
      }
      p {
        text-indent: 2em;
        line-height: 2;
      }
      .matchLevel {
        color: #2055c9;
        font-weight: 700;
        font-size: 17px;
        margin-bottom: 20px;
        text-align: center;
        span {
          display: inline-block;
          color: #57595c;
          margin-left: 10px;
        }
      }
      /deep/.el-table th {
        background-color: #e3e3e3;
        color: #414141;
        font-size: 16px;
      }
      .indexTable {
        /deep/.el-table__body {
          tbody {
            tr:nth-child(1) {
              background-color: #f8f8f8;
              color: #5b5e61;
              font-weight: bold;
            }
          }
        }
        .matchIcon {
          color: #56ad70;
          font-size: 18px;
          vertical-align: text-top;
        }
        .conditionIcon {
          color: #ea7b4d;
          font-size: 18px;
          vertical-align: text-top;
        }
      }
    }
  }
}

.container {
  background: #f5f7fa;
}
.el-tag {
  height: 28px;
  line-height: 26px;
  background: linear-gradient(188deg, #a8bff1 0%, #2055c9 100%);
  border-radius: 5px;
  padding: 0 12px 0;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #fbfbfc;
  // margin-right: 12px;

  max-width: 100%;
  overflow: hidden;
  /* word-break: break-word; */
  text-overflow: ellipsis;
  white-space: nowrap;
}
.result {
  color: #57595c;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  .match-resIcon {
    margin-right: 10px;
  }
}
.reortDownlaid {
  padding: 7px !important;
  float: right;
  margin-right: 80px;
}
</style>
